export default {
  drawer: {
    main: null,
    secondary: null
  },
  color: "success",
  image: ""
}
